const handleMessage = (event) => {
  const DARK_CLASSNAME = "dark";
  if (
    event.data &&
    typeof event.data === "object" &&
    "setTheme" in event.data
  ) {
    const htmlElement = document.querySelector("html");
    const theme = event.data.setTheme;
    if (theme === DARK_CLASSNAME) {
      htmlElement.classList.add(DARK_CLASSNAME);
      htmlElement.setAttribute("data-theme", DARK_CLASSNAME);
    } else {
      htmlElement.classList.remove(DARK_CLASSNAME);
      htmlElement.removeAttribute("data-theme", DARK_CLASSNAME);
    }
  }
};

export default handleMessage;
